import React from "react";

const Text = (props) => {

    return (
        <div className={props.className}>
            { props.children}
        </div>
    )
}

export default Text;